/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./Trigger.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { defineMessages, useIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import EmojiAddIcon from '@atlaskit/icon/core/migration/emoji-add';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Pressable } from '@atlaskit/primitives/compiled';
import { cx } from '@compiled/react';
import React from 'react';
var styles = {
  trigger: "_2rko14q2 _189ee4h9 _1dqonqa1 _1ul9zwfg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1e0c1txw _1bah1h6o _4cvr1h6o",
  subtleTrigger: "_1dqoglyw _1ul91tcg",
  expandedTrigger: "_1ul9146b",
  triggerStylesRefresh: "_2rkoglpi",
  transparentEnabledTrigger: "_1h6dmuej _bfhksm61 _irr3166n _1di61dty",
  opaqueEnabledTrigger: "_1h6dmuej _bfhkvuon _irr3108i _1di61ji5",
  disabledTrigger: "_1h6d13gt _bfhksyzs",
  miniMode: "_2rkoglpi _1dqoglyw _1ul91tcg _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
  fullWidthSummaryViewReactionPickerTrigger: "_1bsb1osq _ca0qu2gc _19bvu2gc _u5f3u2gc",
  fullWidthSelectorTrayReactionPickerTrigger: "_1bsb1osq _ca0q1b66 _19bv1b66 _u5f31b66",
  fullWidth: "_1bsb1osq _p12f3xl8"
};

/**
 * Test id for the tooltip
 */
export var RENDER_TOOLTIP_TRIGGER_TESTID = 'render-tooltip-trigger';
export var RENDER_TRIGGER_BUTTON_TESTID = 'render-trigger-button';
export var RENDER_TRIGGER_CONTAINER_TESTID = 'render-trigger-container';
export var RENDER_LIST_ITEM_WRAPPER_TESTID = 'render-list-item-wrapper';
var i18n = defineMessages({
  addReaction: {
    id: 'reaction-picker-trigger.add.reaction.message',
    description: 'Message displayed when there are no page reactions existing on the page.',
    defaultMessage: 'Add a reaction'
  }
});
var addReactionStyles = {
  addReactionMessage: "_11c8dcr7 _syaz1gjq _18u01b66"
};
var noMarkerListStyle = null;

/**
 * Render an emoji button to open the reactions select picker
 */
export var Trigger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var onClick = props.onClick,
    miniMode = props.miniMode,
    tooltipContent = props.tooltipContent,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$ariaAttributes = props.ariaAttributes,
    ariaAttributes = _props$ariaAttributes === void 0 ? {} : _props$ariaAttributes,
    _props$showOpaqueBack = props.showOpaqueBackground,
    showOpaqueBackground = _props$showOpaqueBack === void 0 ? false : _props$showOpaqueBack,
    _props$showAddReactio = props.showAddReactionText,
    showAddReactionText = _props$showAddReactio === void 0 ? false : _props$showAddReactio,
    _props$subtleReaction = props.subtleReactionsSummaryAndPicker,
    subtleReactionsSummaryAndPicker = _props$subtleReaction === void 0 ? false : _props$subtleReaction,
    reactionPickerTriggerIcon = props.reactionPickerTriggerIcon,
    _props$reactionPicker = props.reactionPickerTriggerText,
    reactionPickerTriggerText = _props$reactionPicker === void 0 ? formatMessage(i18n.addReaction) : _props$reactionPicker,
    _props$fullWidthSumma = props.fullWidthSummaryViewReactionPickerTrigger,
    fullWidthSummaryViewReactionPickerTrigger = _props$fullWidthSumma === void 0 ? false : _props$fullWidthSumma,
    _props$isListItem = props.isListItem,
    isListItem = _props$isListItem === void 0 ? false : _props$isListItem,
    _props$fullWidthSelec = props.fullWidthSelectorTrayReactionPickerTrigger,
    fullWidthSelectorTrayReactionPickerTrigger = _props$fullWidthSelec === void 0 ? false : _props$fullWidthSelec;
  var handleMouseDown = function handleMouseDown(e, analyticsEvent) {
    if (onClick && !disabled) {
      onClick(e, analyticsEvent);
    }
  };
  var renderPressableButton = function renderPressableButton() {
    return /*#__PURE__*/React.createElement(Pressable, _extends({
      testId: RENDER_TRIGGER_BUTTON_TESTID,
      xcss: cx(styles.trigger, (fullWidthSummaryViewReactionPickerTrigger || fullWidthSelectorTrayReactionPickerTrigger) && styles.fullWidth, subtleReactionsSummaryAndPicker && styles.subtleTrigger, showAddReactionText && styles.expandedTrigger, disabled ? styles.disabledTrigger : showOpaqueBackground ? styles.opaqueEnabledTrigger : styles.transparentEnabledTrigger, miniMode && styles.miniMode,
      // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
      fg('platform-component-visual-refresh') && styles.triggerStylesRefresh),
      style: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px'
      },
      onClick: handleMouseDown,
      isDisabled: disabled,
      ref: ref,
      "data-subtle": subtleReactionsSummaryAndPicker,
      "data-mini-mode": miniMode
    }, ariaAttributes), !!reactionPickerTriggerIcon ? reactionPickerTriggerIcon :
    /*#__PURE__*/
    // TODO: https://product-fabric.atlassian.net/browse/DSP-21007
    React.createElement(EmojiAddIcon, {
      testId: "emoji-add-icon",
      color: disabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
      LEGACY_size: "small",
      label: "Add reaction"
    }), showAddReactionText && /*#__PURE__*/React.createElement(Box, {
      xcss: cx(addReactionStyles.addReactionMessage)
    }, reactionPickerTriggerText));
  };
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(fullWidthSummaryViewReactionPickerTrigger && styles.fullWidthSummaryViewReactionPickerTrigger, fullWidthSelectorTrayReactionPickerTrigger && styles.fullWidthSelectorTrayReactionPickerTrigger),
    testId: RENDER_TRIGGER_CONTAINER_TESTID
  }, /*#__PURE__*/React.createElement(Tooltip, {
    testId: RENDER_TOOLTIP_TRIGGER_TESTID,
    content: tooltipContent,
    canAppear: function canAppear() {
      return !showAddReactionText;
    }
  }, isListItem ? /*#__PURE__*/React.createElement("li", {
    "data-testid": RENDER_LIST_ITEM_WRAPPER_TESTID,
    className: ax(["_qtt8glyw"])
  }, renderPressableButton()) : renderPressableButton()));
});